/* src/app/shared-module/components/dialog-edit-team/dialog-edit-team.component.scss */
:host {
  display: block;
}
.det-header {
  display: flex !important;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 14px !important;
  margin: 0 !important;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
  border-bottom: 1px solid var(--ion-color-light-tint);
}
.det-header-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: var(--ion-color-secondary);
  border: 1px solid var(--ion-color-light-tint);
}
.det-header-icon {
  font-size: 24px;
}
.det-header-icon--admin {
  color: #c0392b;
}
.det-header-icon--manager {
  color: #2471a3;
}
.det-header-icon--leader {
  color: #d68910;
}
.det-header-icon--member {
  color: var(--ion-color-secondary-shade);
}
.det-header-copy {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.det-header-kicker {
  display: block;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--ion-color-primary);
  line-height: normal;
}
.det-header-title {
  display: block;
  font-size: 17px;
  font-weight: 700;
  color: var(--ion-color-secondary-shade);
  line-height: 1.25;
}
.det-close-btn {
  flex-shrink: 0;
  color: var(--ion-color-medium) !important;
  background: transparent !important;
}
.det-close-btn:hover {
  color: var(--ion-color-secondary-shade) !important;
}
.det-content {
  padding: 0 !important;
  max-height: 55vh;
  overflow-y: auto;
}
.det-list-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px 6px;
  font-size: 12px;
  color: var(--ion-color-medium);
  font-style: italic;
}
.det-list-hint ion-icon {
  font-size: 15px;
  color: var(--ion-color-primary);
  flex-shrink: 0;
}
.det-selection-list {
  padding: 6px 10px 10px !important;
}
.det-list-option {
  border-radius: 14px !important;
  margin-bottom: 6px;
  border: 1px solid var(--ion-color-light-tint) !important;
  background: var(--ion-color-secondary) !important;
  transition: border-color 0.2s ease, background 0.15s ease;
}
.det-list-option:last-child {
  margin-bottom: 0;
}
.det-list-option.mat-list-single-selected-option,
.det-list-option[aria-selected=true] {
  border-color: var(--ion-color-secondary-shade) !important;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-primary-tint) 0%,
      var(--ion-color-secondary) 100%) !important;
}
.det-list-option.mat-list-single-selected-option .det-option-check,
.det-list-option[aria-selected=true] .det-option-check {
  opacity: 1;
  transform: scale(1);
}
.det-list-option.mat-list-single-selected-option .det-option-name,
.det-list-option[aria-selected=true] .det-option-name {
  color: var(--ion-color-secondary-shade);
  font-weight: 700;
}
.det-option-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 4px;
}
.det-option-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: var(--ion-color-primary-tint);
  border: 1px solid var(--ion-color-light-tint);
}
.det-option-avatar ion-icon {
  font-size: 17px;
  color: var(--ion-color-primary);
}
.det-option-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: var(--ion-color-secondary-shade);
  line-height: 1.3;
}
.det-option-check {
  font-size: 18px;
  color: var(--ion-color-secondary-shade);
  opacity: 0;
  transform: scale(0.6);
  transition: opacity 0.2s ease, transform 0.2s ease;
  flex-shrink: 0;
}
.det-actions {
  display: flex !important;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px !important;
  border-top: 1px solid var(--ion-color-light-tint);
  background:
    linear-gradient(
      180deg,
      var(--ion-color-secondary) 0%,
      var(--ion-color-primary-tint) 100%);
  margin: 0 !important;
  min-height: unset !important;
}
.det-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0 16px !important;
  height: 38px !important;
  border-radius: 12px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  letter-spacing: 0.2px;
  line-height: 1 !important;
}
.det-btn mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
}
.det-btn--cancel {
  color: var(--ion-color-medium-shade) !important;
  border: 1px solid var(--ion-color-light-tint) !important;
  background: var(--ion-color-secondary) !important;
}
.det-btn--confirm {
  color: var(--ion-color-secondary) !important;
  background: var(--ion-color-secondary-shade) !important;
  border: none !important;
}
/*# sourceMappingURL=dialog-edit-team.component.css.map */
